import SearchPatologico from './SearchPatologio'

export default function Index({addEstudiosModal, setTabs, persona, estudios, datosExamenes, setEstudios, getDatos, fechasHoras, setFechasHoras}) {
    
    return (
        <>
            <SearchPatologico fechasHoras={fechasHoras} setFechasHoras={setFechasHoras} getDatos={getDatos} setEstudios={setEstudios} addEstudiosModal={addEstudiosModal} setTabs={setTabs} persona={persona} estudios={estudios} datosExamenes={datosExamenes} />
        </>
    )
}
